module.exports = __webpack_public_path__ + "static/media/icon_tabulation_l.0ff50e0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_tabulation_l.svg
// module id = 340
// module chunks = 0